<template>
  <div class="info">
    <headd></headd>

    <div class="companyinfo container">
      <div v-html="protocol"></div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import headd from "@/components/head";
import foot from "@/components/foot";
import { getprivacypage } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      protocol: ""
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    headd,
    foot
  },
  created() {
    this.getprivacypagedata();
  },
  methods: {
    async getprivacypagedata() {
      var _self = this;
      const res = await getprivacypage();
      var data = res.data.data;

      _self.protocol = data.protocol;
    }
  }
};
</script>

<style lang="less" scoped>
.info {
  .container {
    padding: 0;
    text-align: left;
  }
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
    .container {
      padding: 0;
      text-align: left;
    }
  }
}
.companyinfo {
  flex-direction: column;
  margin: 0.32rem auto;
  width: 8rem;
  @media (max-width: 991px) {
    width: 100%;
    margin: 0 auto 0.32rem auto;
  }
  .com_kv {
    width: 100%;
    margin-bottom: 0.6rem;
    position: relative;

    img {
      width: 100%;
      border-radius: 0.12rem;
    }

    .info_title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.28rem;
      line-height: 0.36rem;
      margin-bottom: 0.2rem;
      flex-direction: column;
      color: #ffffff;
      @media (max-width: 991px) {
        font-size: 0.36rem;
        line-height: 0.42rem;
      }
      ins {
        margin: 0.3rem auto 0;
        width: 1.2rem;
        height: 0.04rem;
        border-radius: 0.02rem;
        background-color: #ffffff;
      }
    }
  }

  .info {
    flex-direction: column;
    margin-bottom: 0.6rem;

    .info_desc {
      font-size: 0.16rem;
      line-height: 0.3rem;
      text-indent: 0.32rem;
      text-align: left;
      @media (max-width: 991px) {
        font-size: 0.26rem;
        line-height: 0.33rem;
      }
    }
  }

  .cy_list {
    flex-direction: column;
    text-align: left;

    .cy_item {
      padding: 0.32rem 0;
      flex-direction: column;
      font-size: 0.16rem;
      line-height: 0.3rem;
      border-top: 0.01rem solid #e5e5e5;
      @media (max-width: 991px) {
        font-size: 0.26rem;
        line-height: 0.33rem;
      }

      div {
        margin-bottom: 0.1rem;
        padding-left: 0.3rem;
      }

      .view {
        position: relative;
        font-size: 0.2rem;
        font-weight: bolder;
        @media (max-width: 991px) {
          font-size: 0.26rem;
          line-height: 0.33rem;
        }

        &::before {
          content: "";
          position: absolute;
          top: 0.03rem;
          left: 0;
          width: 0.2rem;
          height: 0.23rem;
          background: url(../../../static/index/kv/head-icon-1.png) no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/privacy/privacy.vue